// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme/theme';

// MSAL imports
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./auth/msal";

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </MsalProvider>
  </React.StrictMode>
);